import { type JSX } from "react";

import { type AxiosInstances } from "@mobsuccess-devops/react-shared/auth";

import { AuthProvider } from "@/components/AuthProvider/AuthProvider";

type AuthLayerProps = {
  children: JSX.Element;
  axiosInstances: AxiosInstances;
};

// Auth-app-only wrapper hosting the full login flow. Injected into
// createAppRoot's auth slot; every other webapp gets the thin SessionProvider.
export function AuthLayer({
  children,
  axiosInstances,
}: AuthLayerProps): JSX.Element {
  return (
    <AuthProvider
      axiosInstances={axiosInstances}
      googleClientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}
      googleSignupUrl={
        new URL("/google_sign_in.php", import.meta.env.VITE_PLATFORM_ENDPOINT)
      }
      userPoolsId={
        window._msAuth?.userPool?.userPoolsId ??
        import.meta.env.VITE_COGNITO_USER_POOL_ID
      }
      userPoolsWebClientId={
        window._msAuth?.userPool?.userPoolsWebClientId ??
        import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID
      }
    >
      {children}
    </AuthProvider>
  );
}
